import { useContext } from "react"
import { GenerateContext } from "../../../hooks/GenerateContext"
import { IMAGE_TYPE, MODEL_EXPRESSION, MODEL_PROVIDER, RELIGHT_MODE } from "@utils/CONST"
import styles from "./index.module.scss"

const ModelProvider = (props) => {
    const {
        modelProvider,
        setModelProvider,
        setModelKeyList,
        setSceneKeyList,
        setSkinRefine,
        setRelight,
        setRelightMode,
        setEmoji,
    } = useContext(GenerateContext)
    const { imageType, clearModelSelectionOnSota = true } = props

    const items = [
        { label: "ArcMuse", value: MODEL_PROVIDER.ARCMUSE },
        { label: "全能模型", value: MODEL_PROVIDER.SOTA, teamIcon: true },
    ]

    const handleProviderClick = (value) => {
        if (value == MODEL_PROVIDER.SOTA && modelProvider != MODEL_PROVIDER.SOTA) {
            // 切换到全能模型时，隐藏项对应的已选参数一并重置
            if (clearModelSelectionOnSota) {
                setModelKeyList([])
            }
            setSceneKeyList([])
            if (imageType == IMAGE_TYPE.MODEL) {
                setSkinRefine(0)
                setRelight(0)
                setRelightMode(RELIGHT_MODE.SKIN)
                setEmoji(MODEL_EXPRESSION.SRC)
            }
        }
        setModelProvider(value)
    }

    return (
        <div className={styles.Container}>
            <p className={styles.Title}>模型选择</p>
            <div className={styles.PickerContent}>
                {
                    items.map(item => (
                        <div
                            key={item.value}
                            className={`${styles.PickerItem} ${modelProvider == item.value ? styles.actived : ''}`}
                            onClick={() => handleProviderClick(item.value)}
                        >
                            <span>{item.label}</span>
                            {item.teamIcon && <span className={styles.teamIcon}></span>}
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default ModelProvider
